import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

export const CartNotFound = () => (
  <SimpleCard
    title={s__('OrderManagment|Cart not found')}
    description={s__(
      `OrderManagment|Sorry, we encountered an issue loading your cart. Please try again later.`,
    )}
    faIconProps={{ iconName: 'cat-space' }}
    cardProps={{ maxWidth: '720px', margin: '0 auto' }}
  />
);
